import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import React from "react";
import * as types from "../../types";
import { getWidget, getUiOptions, optionsList, getDefaultRegistry } from "../../utils";
function BooleanField(props) {
  var schema = props.schema,
    name = props.name,
    uiSchema = props.uiSchema,
    idSchema = props.idSchema,
    formData = props.formData,
    _props$registry = props.registry,
    registry = _props$registry === void 0 ? getDefaultRegistry() : _props$registry,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    autofocus = props.autofocus,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    rawErrors = props.rawErrors;
  var title = schema.title;
  var widgets = registry.widgets,
    formContext = registry.formContext,
    fields = registry.fields;
  var _getUiOptions = getUiOptions(uiSchema),
    _getUiOptions$widget = _getUiOptions.widget,
    widget = _getUiOptions$widget === void 0 ? "checkbox" : _getUiOptions$widget,
    options = _objectWithoutProperties(_getUiOptions, ["widget"]);
  var Widget = getWidget(schema, widget, widgets);
  var enumOptions;
  if (_Array$isArray(schema.oneOf)) {
    enumOptions = optionsList({
      oneOf: schema.oneOf.map(function (option) {
        return _objectSpread({}, option, {
          title: option.title || (option["const"] === true ? "Yes" : "No")
        });
      })
    });
  } else {
    enumOptions = optionsList({
      "enum": schema["enum"] || [true, false],
      enumNames: schema.enumNames || (schema["enum"] && schema["enum"][0] === false ? ["No", "Yes"] : ["Yes", "No"])
    });
  }
  return React.createElement(Widget, {
    options: _objectSpread({}, options, {
      enumOptions: enumOptions
    }),
    schema: schema,
    id: idSchema && idSchema.$id,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    label: title === undefined ? name : title,
    value: formData,
    required: required,
    disabled: disabled,
    readonly: readonly,
    registry: registry,
    formContext: formContext,
    autofocus: autofocus,
    rawErrors: rawErrors,
    DescriptionField: fields.DescriptionField
  });
}
if (process.env.NODE_ENV !== "production") {}
BooleanField.defaultProps = {
  uiSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false
};
export default BooleanField;